import { useEffect } from 'react';
import LegalPageLayout from './LegalPageLayout';
import { TERMINI_IT } from '../../data/legal/it/termini';

export default function TerminiServizioPage() {
  useEffect(() => {
    document.title = `${TERMINI_IT.titolo} · Marketplace FV`;
  }, []);
  return <LegalPageLayout doc={TERMINI_IT} />;
}
